<app-md-posts [type]="type"></app-md-posts>
